import React from 'react'
import PropTypes from 'prop-types'
import { Button, Paper } from '@material-ui/core'
import { AddShoppingCart, ShoppingCart } from '@mui/icons-material'
import style from './index.module.css'
import Image from '../Image/Image'
import { CURRENCY_ICON } from '../../../utils/User/constants/Payment'
import { handleAddToCart, handleBuy } from '../../../utils/User/helper/functions'

const PesticidePreviewComponent = (props) => {
  const {
    pesticide: {
      name,
      image,
      company, price, discount, quantity, season,
      pesticideDetail: { detail },
      rating: { rating, commment },
      seller: { id: sellerId },
      composition, categoryId, type,
    },
    isAdded,
    history,
    dispatch,
  } = props
  const { pesticide } = props

  return (
    <>
      <div className={ `${ style.background }` }>
        <div className='align-items-center p-2 text-center'>
          <Image
            src={ `${ process.env.REACT_APP_IMAGE_URL }${ image }` }
            alt='product'
            className={ style.image }
          />
          <h5>{ name }</h5>
          <div className=''>
            <span className='text1'>{ composition }</span>
            <span className='text1'>{ quantity }</span>
            <div className='d-flex justify-content-between'>
              <p>Price : </p>
              <p>
                { CURRENCY_ICON.rupee}
                {price }
              </p>
            </div>
            <div className='d-flex justify-content-between'>
              <p>Company : </p>
              <p>{company}</p>
            </div>
            <div className='d-flex justify-content-between'>
              <p>Season : </p>
              <p>{season}</p>
            </div>
            <div className='d-flex justify-content-between'>
              <p>Discount : </p>
              <p>{discount}</p>
            </div>
            <div className='d-flex justify-content-between'>
              <p>Rating : </p>
              <p>{rating}</p>
            </div>
            <div className='d-flex justify-content-between'>
              <p>Details : </p>
              <p>{detail}</p>
            </div>
            <div className='d-flex justify-content-between'>
              <p>Type : </p>
              <p>{type}</p>
            </div>

            {/* <div className=' star mt-3 align-items-center'>
                  {
                  [ ...new Array(rating) ].map((index) => (
                    <i key={ index } className='fa fa-star' />
                  ))
                }
                  {
                  Number(rating) === rating && rating % 1 !== 0 && (<i className='fas fa-star-half-alt' />)
                }
                </div> */}
          </div>
        </div>
        <div className={ style.addToCart }>
          <Button
            type='button'
            color='success'
            onClick={ (e) => handleAddToCart(e, pesticide?.id, history, dispatch) }
            className={ `mr-1 p-1 ${ isAdded && style.goToCart }` }
          >
            {/* <i className=' fas fa-shopping-cart' /> */}
            {' '}
            {/* { isAdded ? 'Go to Cart' : 'Add to Cart' } */}
            { isAdded ? <ShoppingCart /> : <AddShoppingCart /> }
          </Button>
          <Button
            type='button'
            className='p-1'
            color='success'
            onClick={ () => handleBuy(pesticide, history) }
          >
            {/* <i className='fa fa-truck' aria-hidden='true' /> */}
            {' '}
            Buy
          </Button>
        </div>
      </div>
    </>
  )
}

export default PesticidePreviewComponent

PesticidePreviewComponent.propTypes = {
  pesticide: PropTypes.objectOf.isRequired,
  history: PropTypes.objectOf.isRequired,
  isAdded: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
}
